export default __webpack_public_path__ + "static/media/la-regular-400.cf246e21.ttf";